export enum TikTokActionTypes {
  SET_TIKTOK_STEP = 'SET_TIKTOK_STEP',
  SET_TIKTOK_AUTH_LOADING = 'SET_TIKTOK_AUTH_LOADING',
  SET_TIKTOK_BUSINESS_CENTERS = 'SET_TIKTOK_BUSINESS_CENTERS',
  SET_TIKTOK_BUSINESS_CENTERS_LOADING = 'SET_TIKTOK_BUSINESS_CENTERS_LOADING',
  SET_TIKTOK_AUTH_ERROR = 'SET_TIKTOK_AUTH_ERROR',
  SET_TIKTOK_AUTH_CODE = 'SET_TIKTOK_AUTH_CODE',
  SET_TIKTOK_ERRORS = 'SET_TIKTOK_ERRORS',
  SET_TIKTOK_REDIRECT = 'SET_TIKTOK_REDIRECT',
  SET_TIKTOK_REQUESTS_LOADING = 'SET_TIKTOK_REQUESTS_LOADING',
}

export interface ITikTokState {
  step: number
  businessCenters: ITikTokBusinessCenter[]
  isAuthLoading: boolean
  isBusinessCentersLoading: boolean
  errors: any
  isAuthError: boolean
  isRequestsLoading: boolean
  authCode: string
  redirect: string
}

export interface ITikTokAuth {
  auth_code: string
}

export interface ITikTokBusinessCenter {
  bc_id: string
  name: string
}
